import { useLocation } from 'react-router-dom'
import { shallow } from 'zustand/shallow'

import routes from 'src/routes'
import { useAuthState } from 'src/contexts/authContext'
import { useMenuStore } from 'src/store/menu'
import UserProfileDropdown from './UserProfileDropdown'
import UserWalletsDropdown from './UserWalletsDropdown'
import ButtonIcon from 'src/ui/atoms/Button/Icon'

const Header = () => {
  const { pathname } = useLocation()
  const authState = useAuthState()
  const { toggle } = useMenuStore((state) => ({ toggle: state.toggle }), shallow)

  const route = routes.find(({ path }: { path: string }) => path === pathname)
  const title = route?.title?.replace('#name#', authState.user.firstName)

  return (
    <div className="flex h-21 items-center justify-between py-4">
      <div className="flex flex-row items-center gap-4">
        <ButtonIcon
          onClick={toggle}
          className="md:hidden"
          icon="menu"
          type="alternative"
          size="S"
        />

        <h2 className="text-lg text-white md:text-xl">{title}</h2>
      </div>
      <div className="flex gap-4">
        <UserWalletsDropdown />
        <UserProfileDropdown />
      </div>
    </div>
  )
}

export default Header
